// Hook do pobierania raportu KIPG – POST /panel/risk-assessment/:clientId/fetch-report

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const postRiskAssessmentFetchReport = (clientId: number): Promise<IResponse> =>
  axios.post(`/panel/risk-assessment/${clientId}/fetch-report`);

export const usePostRiskAssessmentFetchReport = (
  clientId: number,
  options?: UseMutationOptions<IResponse, IError, void>
) => useMutation(() => postRiskAssessmentFetchReport(clientId), options);
